<template>
	<div class="uniqueform">
		<div class="uniqueform__block dates">
			<span class="uniqueform__title">
				Data di inizio *
			</span>
			<date-picker v-model="fromdate" valueType="timestamp" lang="it" format="ddd, D MMMM YYYY" :disabled-date="(date) => date < new Date()" placeholder="Data" class="dateinput" v-bind:clearable="false" @change="checkRepeats"></date-picker>
			<span class="uniqueform__title">
				Data di fine *
			</span>
			<date-picker v-model="todate" valueType="timestamp" lang="it" format="ddd, D MMMM YYYY" :disabled-date="(date) => date < getEndDate()" placeholder="Data" class="dateinput" v-bind:clearable="false" @change="checkRepeats"></date-picker>

			<span class="uniqueform__dailytrigger">
				<label for="dailyunique" class="uniqueform__dailytrigger__toggle">
					<span class="uniqueform__dailytrigger__toggle__title" v-html="$t('availabilities.daily.label')"></span>
					<input type="checkbox" name="dailyunique" id="dailyunique" class="uniqueform__dailytrigger__toggle__input" @change="setDaily($event)" />
					<span class="uniqueform__dailytrigger__toggle__btn" :class="{ on: dailyActive }"></span>
				</label>
				<span class="moreinfo">
                    <a href="#" @click="openHint">Maggiori informazioni</a>
                </span>
			</span>

			<span class="uniqueform__title" v-show="!dailyActive">
				Orari *
			</span>
			<span class="times__box" v-show="!dailyActive">
				<span class="times__box__label">
					Inizio
				</span>
				<date-picker v-model="fromtime" type="time" format="H:mm" :minute-step="10" :use12h="false" placeholder="Orario" class="timeinput" v-bind:clearable="false"></date-picker>
			</span>
			<span class="times__box" v-show="!dailyActive">
				<span class="times__box__label">
					Fine
				</span>
				<date-picker v-model="totime" type="time" format="H:mm" :minute-step="10" :use12h="false" placeholder="Orario" class="timeinput" v-bind:clearable="false"></date-picker>
			</span>

			{{/* Use both single_booking and dailyActive variables to show discount for total cost or daily availabilities */}}
			<template v-if="!form.single_booking || dailyActive">
				<span class="uniqueform__title">
					Sconto
				</span>
				<span class="discount__box">
					<span class="threshold__box__label">
						Soglia (in {{ dailyActive ? $t('availabilities.discount.days') : $t('availabilities.discount.hours') }})
					</span>
					<input type="number" name="discountthreshold" id="discount-threshold" min="1" v-model="form.discount_threshold" class="prices__number__input width-50" />
				</span>
				<span class="discount__box">
					<span class="amount__box__label">
						Sconto (in &euro;)
					</span>
					<input type="number" name="discountamount" id="discount-amount" min="1" v-model="form.discount_amount" class="prices__number__input width-50" />
				</span>
			</template>
		</div>
		<div class="uniqueform__block prices">
			<span class="uniqueform__title">
				Costi *
			</span>
			<div class="prices__content" v-show="!dailyActive">
				<label for="unihourprice" class="prices__type">
					<input type="radio" name="price" id="unihourprice" class="prices__type__input" checked @change="checkIfSingle($event)" />
					<span class="prices__type__fake"></span>
					<span class="prices__type__label" v-html="$t('availabilities.cost.hourly.label')"></span>
				</label>
				<span v-if="!form.single_booking" class="prices__info" v-html="$t('availabilities.cost.hourly.text')"></span>
				<small v-if="!form.single_booking">&euro;</small>
				<input v-if="!form.single_booking" type="number" name="number" id="number" min="1" v-model="form.price_hour" class="prices__number__input" />
			</div>
			<div class="prices__content">
				<label for="unifullprice" class="prices__type" :class="{ 'disabled': !okmonth }">
					<input type="radio" name="price" id="unifullprice" class="prices__type__input" @change="checkIfSingle($event)" />
					<span class="prices__type__fake"></span>
					<span class="prices__type__label" v-html="$t('availabilities.cost.total.label')"></span>
				</label>
				<span v-if="form.single_booking" class="prices__info" v-html="$t('availabilities.cost.total.text')"></span>
				<small v-if="form.single_booking">&euro;</small>
				<input v-if="form.single_booking" type="number" name="number" id="number" min="1" v-model="form.price" class="prices__number__input" />
			</div>
		</div>
		<div class="uniqueform__block repeats" :class="{ 'disabled': isedit }">
			<span class="uniqueform__repeatrigger">
				<label for="unirepeat" class="uniqueform__repeatrigger__toggle">
					<span class="uniqueform__repeatrigger__toggle__title" v-html="$t('availabilities.repeats.label')"></span>
					<input type="checkbox" name="unirepeat" id="unirepeat" class="uniqueform__repeatrigger__toggle__input" @change="repeats($event)"/>
					<span class="uniqueform__repeatrigger__toggle__btn" :class="{ on: showunirepeat }"></span>
				</label>
			</span>
			<div v-if="showunirepeat" class="uniqueform__repeats rpts">
				<div class="rpts__block">
					<label for="uniweek" class="rpts__type" :class="{ disabled: !okweek }">
						<input type="radio" name="repeat" id="uniweek" class="rpts__type__input" value="WEEK" v-model="form.repeat" />
						<span class="rpts__type__fake"></span>
						<span class="rpts__type__label" v-html="$t('availabilities.repeats.week.label')"></span>
					</label>
					<small v-if="!okweek" class="norepeats" v-html="$t('availabilities.repeats.week.noreps')"></small>
					<div v-if="form.repeat == 'WEEK' && (okweek || form.repeat_number > 1)" class="rpts__block__content inline">
						<small class="rpts__block__title" v-html="$t('availabilities.repeats.week.info')"></small>
						<input type="number" name="number" id="number" min="0" v-model="form.repeat_number" class="rpts__number__input" />
					</div>
				</div>
				<div class="rpts__block">
					<label for="unimonth" class="rpts__type" :class="{ disabled: !okmonth }">
						<input type="radio" name="repeat" id="unimonth" class="rpts__type__input" value="MONTH" v-model="form.repeat" />
						<span class="rpts__type__fake"></span>
						<span class="rpts__type__label" v-html="$t('availabilities.repeats.month.label')"></span>
					</label>
					<small v-if="!okmonth" class="norepeats" v-html="$t('availabilities.repeats.month.noreps')"></small>
					<div v-if="form.repeat == 'MONTH' && (okmonth || form.repeat_number > 1)" class="rpts__block__content inline">
						<small class="rpts__block__title" v-html="$t('availabilities.repeats.month.info')"></small>
						<input type="number" name="number" id="number" min="0" v-model="form.repeat_number" class="rpts__number__input" />
					</div>
				</div>
			</div>
		</div>
		<small v-if="repeatError" class="form__error repeat-error">
			{{ repeatError }}
		</small>
		<div class="uniqueform__block ctas">
			<span class="ctas__btn btn outline" @click="cancelNewSlot">
				{{ $t('common.btns.cancel') }}
			</span>
			<template v-if="!isedit">
				<span class="ctas__btn btn filled" :class="{ disabled: isSaveDisabled }" @click="createNewSlots">
					{{ $t('common.btns.save') }}
				</span>
			</template>
			<template v-else>
				<span class="ctas__btn btn filled" :class="{ disabled: isSaveDisabled }" @click="editSlot">
					{{ $t('common.btns.save') }}
				</span>
			</template>
		</div>
		<div v-if="isLoading" class="singleform__loading">
			<template v-if="!editSaved">
				<span class="singleform__loading__spinner">
					<span class="singleform__loading__spinner__box">
						<Spinner />
					</span>
					<span class="singleform__loading__spinner__label">
						{{ $t('common.is_saving') }}
					</span>
				</span>
			</template>
			<template v-else>
				<span class="singleform__success" :class="{ 'success': !errors }">
					<span class="singleform__success__icon">
						<template v-if="!errors">
							<svg viewBox="0 0 50 50">
								<use xlink:href="#icon--check" width="100%" height="100%"></use>
							</svg>
						</template>
						<template v-else>
							<svg viewBox="0 0 50 50">
								<use xlink:href="#icon--close" width="100%" height="100%"></use>
							</svg>
						</template>
					</span>
					<span class="singleform__success__label">
						<template v-if="!errors">
							<span class="singleform__success__label__txt">
								{{ $t('common.edit_saved') }}
							</span>
						</template>
						<template v-else>
							<span class="singleform__success__label__txt">
								{{ errors }}
							</span>
							<span class="singleform__success__label__btn btn filled" @click="tryAgain">
								{{ $t('availabilities.btns.edit') }}
							</span>
						</template>
					</span>
				</span>
			</template>
		</div>
		<div v-if="hasConflicts" class="singleform__conflict">
			<span class="singleform__conflict__title">
				C'è stato un errore
			</span>
			<template v-if="Array.isArray(conflicts) && conflicts.length">
				<span class="singleform__conflict__text">
					I seguenti intervalli sono già stati inseriti
				</span>
				<span v-for="(c, cI) in conflicts" :key="cI" class="singleform__conflict__item">
					{{ c.start }} <svg viewBox="0 0 50 50"><use xlink:href="#icon--between" width="100%" height="100%"></use></svg> {{ c.end }}
				</span>
				<span class="singleform__conflict__btn btn outline" @click="closeConflict">
					Modifica disponibilità
				</span>
			</template>
			<template v-else-if="conflicts">
				<span class="singleform__conflict__text" v-html="conflicts"></span>
				<span class="singleform__conflict__close" @click="closeConflict">
					Modifica disponibilità
				</span>
			</template>
		</div>
		<div v-if="Array.isArray(errors) && errors.length > 0" class="singleform__errors">
			<span class="singleform__errors__title">
				C'è stato un errore
			</span>
			<span v-if="errors" class="singleform__errors__text" v-html="this.errors.join('<br/>')">
			</span>
			<span class="singleform__errors__close" @click="closeErrors">
				Riprova
			</span>
		</div>
	</div>
</template>
<script>
import { EventBus } from "@/events_bus.js";
import dayjs from "dayjs";
var weekOfYear = require('dayjs/plugin/weekOfYear')
dayjs.extend(weekOfYear);

import { gsap } from "gsap";
import { CustomEase } from "gsap/all";
gsap.registerPlugin(CustomEase);

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import it from 'vue2-datepicker/locale/it';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone')

dayjs.extend(utc);
dayjs.extend(timezone);

const tz = "Europe/Rome";

dayjs.tz.setDefault(tz);

const { CalendarPanel } = DatePicker;

import Spinner from "@/views/components/common/Spinner";

export default {
	name: "UniqueForm",
	props: {
		gid: {
			required: false
		},
		isedit: {
			type: Boolean,
			required: false,
		}
	},
	components: {
		DatePicker,
		CalendarPanel,
		Spinner,
	},
	computed: {
		isSaveDisabled() {
			return this.showunirepeat && !!this.repeatError;
		},
	},
	data() {
		return {
			hasConflicts: false,
			conflicts: null,
			errors: null,
			isLoading: false,
			editSaved: false,
			info: null,
			fromdate: new Date().valueOf(),
			todate: new Date().valueOf(),
			fromtime: null,
			totime: null,
			addTime: false,
			dailyActive: false,
			isEdit: false,
			showunirepeat: false,
			form: {
				id: null,
				start_at: null,
				end_at: null,
				price: 1,
				price_hour: 1,
				single_booking: false,
				garage_id: null,
				range: false,
				repeat: "WEEK",
				repeat_number: 1,
				daily: false,
				discount_threshold: null,
				discount_amount: null,
			},
			lang: {
				days: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
			},
			okweek: true,
			okmonth: true,
			slots: null,
			repeatError: null,
		};
		},
	watch: {
		info: {
			handler(newval, oldval) {
				return newval;
			}
		},
		fromdate: {
			deep: true,
			handler(newval, oldval) {
				this.checkRepeats();
			}
		},
		todate: {
			deep: true,
			handler(newval, oldval) {
				this.checkRepeats();
			}
		},
		fromtime: {
			handler() {
				this.checkRepeats();
			}
		},
		totime: {
			handler() {
				this.checkRepeats();
			}
		},
		'form.repeat_number': {
			handler() {
				this.checkRepeats();
			}
		},
		'form.repeat': {
			handler() {
				if(this.showunirepeat) {
					this.checkRepeats();
				} else {
					this.repeatError = null;
				}
			}
		}
	},
	methods: {
		getEndDate() {
			return new Date(this.fromdate)
		},
		closeConflict() {
			this.hasConflicts = false;
			this.conflicts = null;
		},
		closeErrors() {
			this.errors = null;
		},
		resetSlot() {
			let coeff = 1000 * 60 * 10;
			let date = new Date;
			this.slots = [];
			this.fromdate = new Date().valueOf();
			this.todate = new Date().valueOf();
			this.fromtime = new Date(Math.round(date.getTime() / coeff) * coeff);
			this.totime = new Date(Math.round(date.getTime() / coeff) * coeff);
			this.form.start_at = new Date();
			this.form.end_at = new Date();
			this.form.price = 1;
			this.form.price_hour = 1;
			this.form.single_booking = false;
			this.form.garage_id = null;
			this.form.range = false;
			this.form.repeat = "WEEK";
			this.form.repeat_number = 1;
			this.form.discount_threshold = null;
			this.form.discount_amount = null;

			this.repeatError = null;

			if(this.dailyActive) {
				this.form.single_booking = true;
				this.form.daily = true;

				setTimeout(() => {
					// click on #unifullprice radio
					this.$el.querySelector('#unifullprice').click();
				}, 100)
			} else {
				setTimeout(() => {
					// click on #unihourprice radio
					this.$el.querySelector('#unihourprice').click();
				}, 100)
			}
		},
		setDaily() {
			this.dailyActive = !this.dailyActive;
			
			if(this.dailyActive) {
				this.form.single_booking = true;
				this.form.daily = true;

				let date = new Date(this.fromdate);// keep date start input value
				date.setHours(0, 0, 0, 0)
				this.fromdate = date.valueOf();
				this.fromtime = new Date(date.getTime());

				let dateEnd = new Date(this.todate);// keep date end input value
				dateEnd.setHours(23, 59, 59, 999)
				this.todate = dateEnd.valueOf();
				this.totime = new Date(dateEnd.getTime());

				setTimeout(() => {
					// click on #unifullprice radio
					this.$el.querySelector('#unifullprice').click();
				}, 100)
			} else {
				this.form.daily = false;
				setTimeout(() => {
					// click on #unihourprice radio
					this.$el.querySelector('#unihourprice').click();
				}, 100)
			}
		},
		checkRepeats() {
			if(new Date(this.todate).getTime() < new Date(this.fromdate).getTime()) {
				this.todate = new Date(this.fromdate).valueOf();
			}

			const todayStart = dayjs().startOf('day');
			if(dayjs(this.fromdate).isBefore(todayStart)) {
				this.fromdate = todayStart.valueOf();
			}

			if(!this.showunirepeat) {
				this.okweek = true;
				this.okmonth = true;
				this.repeatError = null;
				return;
			}

			this.repeatError = null;

			const startDate = dayjs(this.fromdate).startOf('day');
			const endDate = dayjs(this.todate).startOf('day');
			const daydiff = endDate.diff(startDate, 'day');

			if(daydiff >= 7) {
				this.okweek = false;
				if(this.form.repeat === 'WEEK') {
					this.repeatError = this.$te && this.$te('availabilities.repeats.week.noreps')
						? this.$t('availabilities.repeats.week.noreps')
						: "L'intervallo scelto è troppo lungo per ripetizioni settimanali.";
					this.form.repeat = null;
				}
			} else {
				this.okweek = true;
			}

			const inclusiveDays = daydiff + 1;
			// Allow at most 31 calendar days between start and end for monthly repeats
			let monthlyValid = inclusiveDays <= 31;
			let monthError = null;

			if(!monthlyValid) {
				monthError = this.$te && this.$te('availabilities.repeats.month.noreps')
					? this.$t('availabilities.repeats.month.noreps')
					: "L'intervallo scelto supera il limite consentito per le ripetizioni mensili.";
			}

			let baseStart = dayjs(this.fromdate);
			let baseEnd = dayjs(this.todate);

			if(this.fromtime) {
				const fromTime = dayjs(this.fromtime);
				baseStart = baseStart
					.hour(fromTime.hour())
					.minute(fromTime.minute())
					.second(0)
					.millisecond(0);
			}

			if(this.totime) {
				const toTime = dayjs(this.totime);
				baseEnd = baseEnd
					.hour(toTime.hour())
					.minute(toTime.minute())
					.second(0)
					.millisecond(0);
			}

			// Next occurrence must start strictly after the current end to avoid overlap
			const firstNextStart = baseStart.add(1, 'month');
			if(monthlyValid && !firstNextStart.isAfter(baseEnd)) {
				monthlyValid = false;
				monthError = this.$te && this.$te('availabilities.repeats.month.overlap')
					? this.$t('availabilities.repeats.month.overlap')
					: "La data di fine supera la successiva data di inizio mensile.";
			}

			if(monthlyValid) {
				// Validate each future occurrence to ensure none overlaps the previous one
				const occurrences = Number(this.form.repeat_number) || 0;
				let previousEnd = baseEnd;

				for(let i = 1; i < occurrences; i++) {
					const nextStart = baseStart.add(i, 'month');
					if(!nextStart.isAfter(previousEnd)) {
						monthlyValid = false;
						monthError = this.$te && this.$te('availabilities.repeats.month.overlap')
							? this.$t('availabilities.repeats.month.overlap')
							: "Le ripetizioni mensili si sovrappongono: riduci la durata o il numero di ripetizioni.";
						break;
					}
					previousEnd = baseEnd.add(i, 'month');
				}
			}

			this.okmonth = monthlyValid;

			if(!monthlyValid && this.form.repeat === 'MONTH') {
				this.repeatError = monthError;
				this.form.repeat = null;
			}
		},
		repeats() {
			this.showunirepeat = !this.showunirepeat;
			if(this.showunirepeat) {
				this.checkRepeats();
			} else {
				this.repeatError = null;
			}
		},
		checkIfSingle(e) {
			let type = e.target.getAttribute('id');
			if(type == 'unihourprice') {
				this.form.single_booking = false;
			} else {// unifullprice
				this.form.single_booking = true;

				if(!this.dailyActive) {
					this.form.discount_threshold = null;
					this.form.discount_amount = null;
				}
			}
		},
		initEdit() {
			this.fromdate = new Date(this.info.start_at).valueOf();
			this.todate = new Date(this.info.end_at).valueOf();
			this.fromtime = new Date(this.info.start_at);
			this.totime = new Date(this.info.end_at);
			this.form.price = this.info.price;
			this.form.price_hour = this.info.price_hour;
			this.form.single_booking = this.info.single_booking;
			this.form.range = this.info.range;
			this.form.repeat = this.info.repeat;
			this.form.repeat_number = this.info.repeat_number;
			this.form.garage_id = this.info.garage_id;
			this.form.id = this.info.id;
			this.form.discount_threshold = this.info.discount_threshold;
			this.form.discount_amount = this.info.discount_amount;
			console.log('unique', {info: this.info})
			if(this.info.daily) {
				// revert because setDaily will toggle it
				this.dailyActive = false;
				this.setDaily();
			} else {
				// revert because setDaily will toggle it
				this.dailyActive = true;
				this.setDaily();
			}

			setTimeout(() => {
				this.$forceUpdate();

				// click on correct price radio
				if(this.info.single_booking) {
					this.$el.querySelector('#unifullprice').click();
				} else if(!this.info.daily) {
					// not click if daily=1
					this.$el.querySelector('#unihourprice').click();
				}
			}, 100)
		},
		init() {
			this.dailyActive = false;
			if(this.gid) {
				this.form.garage_id = this.gid;
			}
			setTimeout(() => {
				this.resetSlot();
			}, 100)
		},
		cancelNewSlot() {
			this.resetSlot();
			EventBus.$emit('close-avaform', this.info);
		},
		repeatWeeks() {
			const occurrences = Number(this.form.repeat_number) || 0;
			if(!this.okweek || occurrences <= 0) {
				return;
			}

			for(let i = 0; i < occurrences; i++) {
				this.slots.push({
					start_at: dayjs(this.fromdate).hour(this.startHours.hour).minute(this.startHours.min).add(i, 'week').toISOString(),
					end_at: dayjs(this.todate).hour(this.endHours.hour).minute(this.endHours.min).add(i, 'week').toISOString(),
					price: this.form.price,
					price_hour: this.form.price_hour,
					single_booking: this.form.single_booking,
					garage_id: this.gid,
					repeat: "WEEK",
					repeat_number: occurrences,
					daily: this.dailyActive,
					discount_threshold: this.form.discount_threshold,
					discount_amount: this.form.discount_amount,
				})
			}

			if(this.slots.length) {
				this.saveAvailability();
			}
		},
		repeatMonths() {
			const occurrences = Number(this.form.repeat_number) || 0;
			if(!this.okmonth || occurrences <= 0) {
				return;
			}

			for(let i = 0; i < occurrences; i++) {
				this.slots.push({
					start_at: dayjs(this.fromdate).hour(this.startHours.hour).minute(this.startHours.min).add(i, 'month').toISOString(),
					end_at: dayjs(this.todate).hour(this.endHours.hour).minute(this.endHours.min).add(i, 'month').toISOString(),
					price: this.form.price,
					price_hour: this.form.price_hour,
					single_booking: this.form.single_booking,
					garage_id: this.gid,
					repeat: "MONTH",
					repeat_number: occurrences,
					daily: this.dailyActive,
					discount_threshold: this.form.discount_threshold,
					discount_amount: this.form.discount_amount,
				})
			}

			if(this.slots.length) {
				this.saveAvailability();
			}
		},
		createNewSlots() {
			if(this.showunirepeat && this.repeatError) {
				window.alert(this.repeatError);
				return;
			}

			let useRepeat = this.showunirepeat && !!this.form.repeat;
			if(useRepeat) {
				const occurrences = Number(this.form.repeat_number);
				const repeatAllowed = this.form.repeat === 'WEEK' ? this.okweek : this.okmonth;
				if(!repeatAllowed || !occurrences || occurrences <= 0) {
					useRepeat = false;
					this.showunirepeat = false;
					this.form.repeat = null;
					this.repeatError = null;
				}
			} else if(this.showunirepeat && !this.form.repeat) {
				this.showunirepeat = false;
				this.repeatError = null;
			}

			this.isLoading = true;
			this.slots = [];
			this.startHours = {
				hour: dayjs(this.fromtime).hour(),
				min: dayjs(this.fromtime).minute()
			};
			this.endHours = {
				hour: dayjs(this.totime).hour(),
				min: dayjs(this.totime).minute()
			};

			this.form.start_at = dayjs(this.fromdate).hour(this.startHours.hour).minute(this.startHours.min).toISOString();

			this.form.end_at = dayjs(this.todate).hour(this.endHours.hour).minute(this.endHours.min).toISOString();

			if(!useRepeat) {
				this.form.garage_id = this.gid;
				this.slots.push(this.form);
				this.saveAvailability();
			} else {
				switch(this.form.repeat) {
					case 'WEEK':
						this.repeatWeeks();
						break;
					case 'MONTH':
						this.repeatMonths();
						break;
				}
			}
		},
		editSlot() {
			if(this.showunirepeat && this.repeatError) {
				window.alert(this.repeatError);
				return;
			}

			let useRepeat = this.showunirepeat && !!this.form.repeat;
			if(useRepeat) {
				const occurrences = Number(this.form.repeat_number);
				const repeatAllowed = this.form.repeat === 'WEEK' ? this.okweek : this.okmonth;
				if(!repeatAllowed || !occurrences || occurrences <= 0) {
					useRepeat = false;
					this.showunirepeat = false;
					this.form.repeat = null;
					this.repeatError = null;
				}
			} else if(this.showunirepeat && !this.form.repeat) {
				this.showunirepeat = false;
				this.repeatError = null;
			}

			this.isLoading = true;
			this.slots = [];
			this.startHours = {
				hour: dayjs(this.fromtime).hour(),
				min: dayjs(this.fromtime).minute()
			};
			this.endHours = {
				hour: dayjs(this.totime).hour(),
				min: dayjs(this.totime).minute()
			};

			this.form.start_at = dayjs(this.fromdate).hour(this.startHours.hour).minute(this.startHours.min).toISOString();

			this.form.end_at = dayjs(this.todate).hour(this.endHours.hour).minute(this.endHours.min).toISOString();

			setTimeout(() => {
				this.$service.availability.detail.put(this.info.id, this.form).then(res => {
					this.errors = null;
					this.editSaved = true;
					setTimeout(() => {
						this.isLoading = false;
						EventBus.$emit('return-to-list', this.info);
						this.resetSlot();
					}, 1500)
				}).catch(err => {
					this.isLoading = false;
					this.editSaved = false;
					if(err && err.status) {
						this.errors = null;
						this.conflicts = null;
						this.hasConflicts = false;
						switch (err.status) {
							case 409:
								this.hasConflicts = true;
								this.conflicts = this.$t('availabilities.errors.conflict');
								break;
							case 400:
								this.errors = this.$t('availabilities.errors.badrequest');
								break;
						}
					} else if(err && err.messages && err.messages.data && err.messages.data.length) {
						this.errors = null;
						this.conflicts = [];
						this.hasConflicts = true;
						err.messages.data.forEach(d => {
							this.conflicts.push({
								start: dayjs(d.start_at).format('DD/MM/YYYY - HH:mm'),
								end: dayjs(d.end_at).format('DD/MM/YYYY - HH:mm')
							});
						})
					}
					console.error('ERR', err);
				})
			}, 100)
		},
		saveAvailability() {
			this.$service.availability.multiple(this.slots).then(res => {
				this.errors = null;
				this.editSaved = true;
				setTimeout(() => {
					this.isLoading = false;
					EventBus.$emit('return-to-list', this.info);
					this.resetSlot();
				}, 1500)
			}).catch(err => {
				this.isLoading = false;
				this.editSaved = false;
				if(err && err.status) {
					this.errors = null;
					this.conflicts = null;
					this.hasConflicts = false;
					switch (err.status) {
						case 409:
							this.hasConflicts = true;
							this.conflicts = this.$t('availabilities.errors.conflict');
							break;
						default:
							this.errors = (Array.isArray(this.errors)) ? this.errors : [];
							this.errors.push(this.$t('availabilities.errors.badrequest'));
							this.isLoading = false;
							break;
					}
				} else if(err && err.messages && err.messages.data && err.messages.data.length) {
					this.errors = null;
					this.conflicts = [];
					this.hasConflicts = true;
					err.messages.data.forEach(d => {
						this.conflicts.push({
							start: dayjs(d.start_at).format('DD/MM/YYYY - HH:mm'),
							end: dayjs(d.end_at).format('DD/MM/YYYY - HH:mm')
						});
					})
				}
				console.error('ERR', err);
			})
		},
		openHint() {
			EventBus.$emit('open-hint-unique');
        },
	},
	mounted() {
		
	},
	created() {
		EventBus.$on("open-unique", info => {
			this.info = info;
			if(info.isedit) {
				this.initEdit();
				this.$forceUpdate();
			} else {
				this.init();
			}
		});
	},
	destroyed() {
		EventBus.$off("open-unique");
	}
};
</script>
<style lang="scss">
.uniqueform {
	&__block {
		@extend %panel;
		display: block;
		width: 100%;
		margin-bottom: var(--minigutter);
		padding: var(--gutter);
		&.ctas {
			display: flex;
			flex-direction: column;
			background: none;
			box-shadow: 0;
			padding: 0;
			margin: var(--gutter) 0;
			.ctas {
				&__btn {
					margin-bottom: var(--minigutter);
					&.disabled {
						opacity: 0.6;
						pointer-events: none;
					}
					&.filled {
						background: $color-blue;
						color: $color-white;
						order: 1;
					}
					&.outline {
						order: 2;
					}
				}
			}
		}
	}
	&__title {
		display: block;
		width: 100%;
		font-variation-settings: 'wght' 700;
		margin-bottom: var(--minigutter);
		&:not(:first-of-type) {
			margin-top: var(--gutter);
		}
	}
	.dates {
		@extend %flexCenterStart;
		flex-wrap: wrap;
		width: 100%;
		.times {
			&__box {
				@extend %flexCenterStart;
				width: 50%;
				&:last-child {
					justify-content: flex-end
				}
				&__label {
					@extend %text-14;
					display: block;
					padding-right: var(--thirdgutter);
				}
			}
		}
		.discount {
			&__box {
				margin-bottom: var(--minigutter);
			}
		}
	}
	.prices {
		&__content {
			@extend %flexStartBetween;
			flex-wrap: wrap;
			width: 100%;
		}
		&__info {
			display: block;
			width: calc(100% - var(--hourinputsmall) - 20px);
			@extend %text-13;
			color: $color-davy;
			padding-left: var(--gutter);
		}
		small {
			@extend %flexCenterCenter;
			@include size(20px, var(--input));
			@extend %text-18;
			font-variation-settings: 'wght' 300;
		}
		&__type {
			@extend %text-15;
			@extend %flexCenterStart;
			width: 100%;
			font-variation-settings: "wght" 600;
			margin: var(--minigutter) 0;
			cursor: pointer;
			&.disabled {
				opacity: 0.5;
				pointer-events: none;
			}
			&__input {
				display: none;
			}
			&__fake {
				display: block;
				@include size(
					calc(var(--thirdgutter) * 2),
					calc(var(--thirdgutter) * 2)
				);
				border: 2px solid $color-blue;
				border-radius: 100%;
				position: relative;
				margin-right: var(--thirdgutter);
				&:after {
					content: "";
					position: absolute;
					top: 50%;
					left: 50%;
					display: block;
					background: $color-blue;
					@include size(65%, 65%);
					border-radius: 100%;
					transform: translate(-50%, -50%) scale(0);
					transition: 180ms linear;
				}
			}
			&__input:checked ~ .prices__type__fake {
				&:after {
					transform: translate(-50%, -50%) scale(1);
				}
			}
			&__input:not(:checked) ~ .prices__type__fake {
				&:after {
					transform: translate(-50%, -50%) scale(0);
				}
			}
		}
		&__number {
			@extend %flexCenterBetween;
			width: var(--hourinputsmall);
			margin-top: var(--gutter);
			&__label {
				display: block;
				width: calc(100% - var(--hourinputsmall));
				padding-right: var(--thirdgutter);
				&__txt,
				&__info {
					display: block;
					width: 100%;
				}
				&__txt {
					@extend %text-15;
					font-variation-settings: 'wght' 600;
				}
			}
			&__input {
				@include size(var(--hourinputsmall), var(--input));
				border: 1px solid $color-silver;
				padding: var(--thirdgutter);
				text-align: center;
				border-radius: var(--inputradius);
			}
			
		}
	}
	&__dailytrigger,
	&__repeatrigger  {
		display: block;
		width: 100%;
		margin: var(--gutter) 0 0;
		&__toggle {
			@extend %flexCenterBetween;
			width: 100%;
			cursor: pointer;
			& * {
				pointer-events: none;
			}
			&__input {
				display: none;
			}
			&__label {
				@extend %text-15;
				display: block;
				font-family: $font-manrope;
				padding-right: var(--thirdgutter);
			}
			&__btn {
				display: block;
				@include size(48px, 22px);
				border-radius: var(--minigutter);
				border: 1px solid $color-davy;
				position: relative;
				&:before {
					content: "";
					position: absolute;
					top: 50%;
					left: 2px;
					display: block;
					background: $color-blue;
					@include size(16px, 16px);
					border-radius: 100%;
					transform: translateY(-50%);
					transition: 180ms linear;
					filter: grayscale(1);
				}
				&.on {
					&:before {
						left: calc(100% - 18px);
						filter: grayscale(0);
					}
				}
			}
		}
	}
	.repeats {
		&.disabled {
			opacity: 0.4;
			filter: grayscale(1);
			pointer-events: none;
		}
	}
	&__repeats {
		display: block;
		width: 100%;
		margin-top: var(--minigutter);
		.rpts {
			&__block {
				display: block;
				width: 100%;
				.norepeats {
					display: block;
					width: 100%;
					padding-left: var(--gutter);
				}
				&__title {
					display: block;
					width: 100%;
					margin-bottom: var(--thirdgutter);
					font-variation-settings: "wght" 600;
					color: $color-davy;
					&:not(:first-of-type) {
						margin-top: calc(var(--minigutter) * 1.5);
					}
				}
				&__content {
					@extend %flexCenterBetween;
					width: 100%;
					padding: 0 0 0 var(--gutter);
					.dateinput {
						margin-bottom: var(--minigutter);
					}
					.weekdays {
						display: block;
						@include size(var(--smallicon), var(--smallicon));
						margin: 0 6px;
						position: relative;
						&__input {
							position: absolute;
							top: 0;
							left: 0;
							opacity: 0;
							z-index: 0;
						}
						&__fake {
							position: absolute;
							top: 50%;
							left: 50%;
							@extend %text-14;
							@extend %flexCenterCenter;
							@include size(100%, 100%);
							color: $color-black;
							border-radius: 100%;
							transform: translate(-50%, -50%);
							transition: 180ms linear;
							z-index: 1;
						}
						&__input:checked ~ .weekdays__fake {
							background: $color-blue;
							color: $color-white;
						}
						&__input:not(:checked) ~ .weekdays__fake {
							background: $color-white;
							color: $color-blue;
						}
					}
				}
			}
			&__type {
				@extend %text-15;
				@extend %flexCenterStart;
				width: 100%;
				font-variation-settings: "wght" 600;
				margin: var(--minigutter) 0;
				cursor: pointer;
				&__input {
					display: none;
				}
				&__fake {
					display: block;
					@include size(
						calc(var(--thirdgutter) * 2),
						calc(var(--thirdgutter) * 2)
					);
					border: 2px solid $color-blue;
					border-radius: 100%;
					position: relative;
					margin-right: var(--thirdgutter);
					&:after {
						content: "";
						position: absolute;
						top: 50%;
						left: 50%;
						display: block;
						background: $color-blue;
						@include size(65%, 65%);
						border-radius: 100%;
						transform: translate(-50%, -50%) scale(0);
						transition: linear;
					}
				}
				&__input:checked ~ .rpts__type__fake {
					&:after {
						transform: translate(-50%, -50%) scale(1);
					}
				}
				&__input:not(:checked) ~ .rpts__type__fake {
					&:after {
						transform: translate(-50%, -50%) scale(0);
					}
				}
				&.disabled {
					opacity: 0.4;
					pointer-events: none;
					filter: grayscale(1);
				}
			}
			&__number {
				@extend %flexCenterBetween;
				width: 100%;
				margin-top: var(--gutter);
				&__label {
					display: block;
					width: calc(100% - var(--hourinputsmall));
					padding-right: var(--thirdgutter);
					&__txt,
					&__info {
						display: block;
						width: 100%;
					}
					&__txt {
						@extend %text-15;
						font-variation-settings: 'wght' 600;
					}
				}
				&__input {
					@include size(var(--hourinputsmall), var(--input));
					border: 1px solid $color-silver;
					padding: var(--thirdgutter);
					text-align: center;
					border-radius: var(--inputradius);
				}
			}
		}
	}
	&__price {
		display: block;
		width: 100%;
		margin-top: var(--gutter);
		.price {
			&__title {
				display: block;
				width: max-content;
			}
			&__content {
				@extend %flexCenterBetween;
				width: 100%;
			}
			&__type {
				@extend %text-15;
				@extend %flexCenterStart;
				width: 100%;
				font-variation-settings: "wght" 600;
				margin: var(--minigutter) 0;
				&__input {
					display: none;
				}
				&__fake {
					display: block;
					@include size(
						calc(var(--thirdgutter) * 2),
						calc(var(--thirdgutter) * 2)
					);
					border: 2px solid $color-blue;
					border-radius: 100%;
					position: relative;
					margin-right: var(--thirdgutter);
					&:after {
						content: "";
						position: absolute;
						top: 50%;
						left: 50%;
						display: block;
						background: $color-blue;
						@include size(65%, 65%);
						border-radius: 100%;
						transform: translate(-50%, -50%) scale(0);
						transition: 180ms linear;
					}
				}
				&__input:checked ~ .prices__type__fake {
					&:after {
						transform: translate(-50%, -50%) scale(1);
					}
				}
				&__input:not(:checked) ~ .prices__type__fake {
					&:after {
						transform: translate(-50%, -50%) scale(0);
					}
				}
			}
			&__number {
				@extend %flexCenterBetween;
				width: var(--hourinputsmall);
				margin-top: var(--gutter);
				&__label {
					display: block;
					width: calc(100% - var(--hourinputsmall));
					padding-right: var(--thirdgutter);
					&__txt,
					&__info {
						display: block;
						width: 100%;
					}
					&__txt {
						@extend %text-15;
						font-variation-settings: 'wght' 600;
					}
				}
				&__input {
					@include size(var(--hourinputsmall), var(--input));
					border: 1px solid $color-silver;
					padding: var(--thirdgutter);
					text-align: center;
					border-radius: var(--inputradius);
				}
			}
		}
	}
	.dateinput {
		&.mx-datepicker {
			width: 100%;
			.mx-input {
				background: $color-white;
				height: var(--input);
				border: 1px solid $color-white;
				border-radius: var(--inputradius);
				padding: 0 var(--minigutter);
				border: 1px solid $color-grey;
			}
			.mx-icon-calendar {
				svg {
					fill: $color-black;
				}
			}
		}
	}
	.timeinput {
		&.mx-datepicker {
			width: var(--hourinputsmall) !important;
			margin-right: 1%;
			&-list {
				list-style: none;
				&:after {
					display: none !important;
				}
			}
			&-item {
				padding: 0;
				&:before {
					display: none;
				}
			}
			.mx-input {
				background: $color-white;
				height: var(--input);
				border: 1px solid $color-white;
				border-radius: var(--inputradius);
				padding: 0 var(--thirdgutter);
				border: 1px solid $color-grey;
			}
			.mx-icon-calendar {
				svg {
					fill: $color-black;
				}
			}
		}
	}
	&__loading {
		position: absolute;
		top: 0;
		left: 0;
		@extend %flexCenterCenter;
		background: rgba($color-white, 0.86);
		@include size(100%,100%);
		pointer-events: all;
		z-index: 100;
		&__spinner {
			display: block;
			margin-bottom: var(--gutter);
			&__box {
				display: block;
				@include size(65px,65px);
				margin: 0 auto var(--gutter);
			}
			&__label {
				@extend %text-15;
				display: block;
				width: 100%;
				font-family: $font-manrope;
				font-variation-settings: 'wght' 600;
				text-align: center;
			}
		}
	}
	&__success {
		@extend %flexCenterCenter;
		flex-direction: column;
		text-align: center;
		&__icon {
			@extend %flexCenterCenter;
			background: $color-success;
			@include size(var(--supergutter),var(--supergutter));
			border-radius: 100%;
			margin-bottom: var(--gutter);
			overflow: hidden;
			svg {
				display: block;
				@include size(var(--smallicon),var(--smallicon));
				fill: $color-white;
			}
		}
		&__label {
			display: block;
			padding: var(--gutter) var(--supergutter);
			&__txt {
				display: block;
				width: 100%;
				@extend %text-33;
				font-variation-settings: 'wght' 700;
				color: $color-success;
				margin-bottom: var(--gutter);
			}
			&__btn {
				width: max-content;
				padding: 0 var(--supergutter);
				margin: 0 auto;
				background: $color-blue;
				color: $color-white;
			}
		}
		&.success {
			.availability__success {
				&__icon {
					background: $color-success;
				}
				&__label {
					&__txt {
						color: $color-success;
					}
				}
			}
		}
	}
	&__errors,
	&__conflict {
		position: absolute;
		top: 0;
		left: 0;
		@extend %flexCenterCenter;
		flex-direction: column;
		flex-wrap: wrap;
		background: rgba($color-white, 0.92);
		@include size(100%,100%);
		padding: var(--gutter);
		pointer-events: all;
		z-index: 100;
		&__title {
			@extend %text-20;
			display: block;
			width: 100%;
			font-family: $font-manrope;
			font-variation-settings: 'wght' 700;
			color: $color-error;
			margin-bottom: var(--minigutter);
			text-align: center;
		}
		&__list {
			display: block;
			width: 100%;
			max-height: 400px;
			overflow: auto;
		}
		&__text {
			display: block;
			width: 100%;
			text-align: center;
			margin-bottom: var(--minigutter);
		}
		&__item {
			@extend %flexCenterCenter;
			width: 100%;
			margin-bottom: var(--thirdgutter);
			svg {
				display: block;
				@include size(20px, 20px);
				fill: $color-davy;
				margin: 0 var(--minigutter);
			}
		}
		&__btn {
			display: block;
			width: max-content;
			padding: 0 var(--gutter);
			margin: var(--gutter) auto 0;
		}
	}
	.discount {
		&__box {
			align-items: center;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			width: 100%;
		}
	}
	@media (min-width: $from-large) {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		.dates,
		.prices {
			width: 48%;
		}
		&__block {
			&.ctas {
				flex-direction: row;
				justify-content: flex-end;
				box-shadow: unset;
				.ctas {
					&__btn {
						width: max-content;
						padding: 0 var(--supergutter);
						&.outline { order: 1; }
						&.filled {
							order: 2;
							margin-left: var(--minigutter);
						}
					}
				}
			}
		}
	}
}
.mx-calendar-content {
	.cell {
		position: relative;
		&.active {
			background-color: $color-blue !important;
			div {
				@extend %flexCenterCenter;
				top: 0;
				left: 0;
				@include size(100%,100%);
			}
		}
	}
}
.mx-time {
	width: var(--hourinputsmall) !important;
	&-list {
		list-style: none;
		&:after {
			display: none !important;
		}
	}
	&-item {
		padding: 0;
		&:before {
			display: none;
		}
	}
}
.moreinfo {
	@extend %text-13;
	display: block;
	width: 100%;
	/*color: $color-davy;*/
	color: $color-blue;
}
</style>
